export default "__VITE_ASSET__BIWtc$q3__$_?nuxt_component=async&nuxt_component_name=Svgo商务舱&nuxt_component_export=default__"